import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import FormDataContext from "integrations/contexts/FormDataContext";
import formValidation from "./utils/formValidation";
import FormWrap from "../common/FormWrap";
import ValidatedInput from "../common/ValidatedInput";
import handleFileUpload from "../helpers/fileReader";
const StepAuthorize = ({ onSubmit, onChange }) => {
  const { t } = useTranslation("enterprise_integrations");
  const { formData } = useContext(FormDataContext);
  const [formValidated, setFormValidated] = useState({
    workspaceNameCheck: true,
    accountIdCheck: true,
    accountUserCheck: true,
    serviceAccountKeyCheck: true,
    clientIdCheck: true
  });
  const ValidatedInputData = [
    { name: "workspaceName", type: "string", minLength: 3, maxLength: 31 },
    { name: "accountId", type: "email", minLength: 0 },
    { name: "accountUser", type: "email", minLength: 0 },
    { name: "serviceAccountKey", type: "string", minLength: 0 },
    { name: "clientId", type: "number", minLength: 11, maxLength: 31 }
  ];
  const isFormValid = formValidation.isFormValid(
    ["workspaceName", "accountId", "accountUser", "serviceAccountKey", "clientId"],
    formData
  );
  const formSubmit = (event) => {
    const errors = [];
    const email = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
    const number = /^[0-9\b]+$/;
    ValidatedInputData.forEach((data) => {
      var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
      if (data.name === "workspaceName" && (((_b = (_a = formData[data.name]) == null ? void 0 : _a.value) == null ? void 0 : _b.length) <= data.minLength || ((_d = (_c = formData[data.name]) == null ? void 0 : _c.value) == null ? void 0 : _d.length) >= data.maxLength)) {
        errors.push(data.name);
        setFormValidated((prevData) => ({
          ...prevData,
          [`${data.name}Check`]: false
        }));
      } else if (data.type === "email" && !email.test((_e = formData[data.name]) == null ? void 0 : _e.value)) {
        errors.push(data.name);
        setFormValidated((prevData) => ({
          ...prevData,
          [`${data.name}Check`]: false
        }));
      } else if (data.name === "clientId" && (!number.test((_f = formData[data.name]) == null ? void 0 : _f.value) || ((_h = (_g = formData[data.name]) == null ? void 0 : _g.value) == null ? void 0 : _h.length) <= data.minLength || ((_j = (_i = formData[data.name]) == null ? void 0 : _i.value) == null ? void 0 : _j.length) >= data.maxLength)) {
        errors.push(data.name);
        setFormValidated((prevData) => ({
          ...prevData,
          [`${data.name}Check`]: false
        }));
      }
    });
    if (errors.length === 0) {
      onSubmit(event);
    }
  };
  const fieldChange = (event, value) => {
    if (event) {
      setFormValidated((prevData) => ({
        ...prevData,
        [value]: true
      }));
      onChange(event);
    }
  };
  const onFileUpload = (e, validationKey) => {
    e.persist();
    setFormValidated((prevData) => ({
      ...prevData,
      [validationKey]: true
    }));
    handleFileUpload(e.target.files[0], (fileName, fileContent) => onChange(e, { fileName, fileContent }));
  };
  const accountKeyHelpText = formData.serviceAccountKey && formData.serviceAccountKey.fileName ? t("googleworkspace.authorize.currently_using_file", { fileName: formData.serviceAccountKey.fileName }) : t("googleworkspace.authorize.service_account_key_help");
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: (e) => formSubmit(e),
      buttonContent: t("common.buttons.proceed"),
      disabled: isFormValid,
      title: "",
      description: ""
    },
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        id: "workspaceName",
        type: "text",
        fieldData: formData.workspaceName,
        onChange: (e) => fieldChange(e, "workspaceNameCheck"),
        placeholder: t("common.fields.input_name"),
        label: t("common.fields.input_name"),
        autoComplete: "off",
        help: t("common.fields.input_name_help"),
        required: true
      }
    ),
    !formValidated.workspaceNameCheck && /* @__PURE__ */ React.createElement("label", { htmlFor: "clientId" }, t("googleworkspace.authorize.name_length_error")),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        id: "clientId",
        type: "text",
        fieldData: formData.clientId,
        onChange: (e) => fieldChange(e, "clientIdCheck"),
        label: t("googleworkspace.authorize.client_id"),
        help: t("googleworkspace.authorize.client_id_help"),
        autoComplete: "off",
        required: true
      }
    ),
    !formValidated.clientIdCheck && /* @__PURE__ */ React.createElement("label", { htmlFor: "accountId" }, t("googleworkspace.authorize.client_id_error")),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        id: "accountId",
        type: "text",
        fieldData: formData.accountId,
        onChange: (e) => fieldChange(e, "accountIdCheck"),
        label: t("googleworkspace.authorize.service_account_id"),
        help: t("googleworkspace.authorize.service_account_id_help"),
        autoComplete: "off",
        required: true
      }
    ),
    !formValidated.accountIdCheck && /* @__PURE__ */ React.createElement("label", { htmlFor: "accountUser" }, t("googleworkspace.authorize.invalid_email")),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        id: "accountUser",
        type: "text",
        onChange: (e) => fieldChange(e, "accountUserCheck"),
        fieldData: formData.accountUser,
        help: t("googleworkspace.authorize.account_user_email_help"),
        label: t("googleworkspace.authorize.account_user_email"),
        required: true
      }
    ),
    !formValidated.accountUserCheck && /* @__PURE__ */ React.createElement("label", { htmlFor: "serviceAccountKey" }, t("googleworkspace.authorize.invalid_email")),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        id: "serviceAccountKey",
        type: "file",
        onChange: (e) => onFileUpload(e, "serviceAccountKeyCheck"),
        fieldData: formData.serviceAccountKey,
        label: t("googleworkspace.authorize.service_account_key"),
        help: accountKeyHelpText,
        accept: ".p12",
        required: true
      }
    )
  );
};
export default StepAuthorize;
